import { getLocale } from 'core/store/selectors/getLocale';
import { SupportedLocale } from 'core/utils/numberFormat';
import { useSelector } from 'react-redux';

export function useLocale(): SupportedLocale {
  return useSelector((state: unknown) => getLocale(state));
}
